import { useCallback, useState } from "react";

export type GroupExpandState = Record<string, boolean>;

export function useGroupExpansion() {
    const [groupExpandStates, setGroupExpandStates] = useState<GroupExpandState>({});

    const isGroupExpanded = useCallback(
        (groupName: string, isSearchActive: boolean): boolean => {
            if (isSearchActive) {
                return true;
            }
            return groupExpandStates[groupName] ?? true;
        },
        [groupExpandStates],
    );
    const toggleGroupExpanded = useCallback((groupName: string) => {
        setGroupExpandStates((prev) => ({
            ...prev,
            [groupName]: !(prev[groupName] ?? true),
        }));
    }, []);

    return {
        groupExpandStates,
        isGroupExpanded,
        toggleGroupExpanded,
    };
}
